import React, { useEffect, useRef, useState } from 'react';
import { PDFDocument } from 'pdf-lib';

const OriginalDocumentView = ({ data, blobBuffer }) => {

    console.log('data hsagdjas -->', data)
    const iframeRef = useRef(null);



    useEffect(() => {
        const convertAndDisplayPDF = async () => {
            try {
                // Extract PNG image data from the Buffer
                const pngImageBytes = new Uint8Array(data.pdf_url_buffer.data);

                // Convert PNG to PDF
                const pdfDoc = await PDFDocument.create();
                // const page = pdfDoc.addPage();
                const pngImage = await pdfDoc.embedPng(pngImageBytes);
                const { width, height } = pngImage.scale(1);
                const page = pdfDoc.addPage([width, height]);
                const xCoordinate = (page.getWidth() - width) / 2;
                const yCoordinate = page.getHeight() - height - 50;

                // Set the y-coordinate to position image at the top of the page
                page.drawImage(pngImage, {
                    x: xCoordinate,
                    y: yCoordinate,
                    width,
                    height,
                });

                const pdfBytes = await pdfDoc.save();

                // Convert PDF bytes to Base64 string

                const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf'});

                const pdfBlobUrl = URL.createObjectURL(pdfBlob)

                // const pdfDataUrl = 'data:application/pdf;base64,' + btoa(Uint8Array.from(pdfBytes).reduce((data, byte) => data + String.fromCharCode(byte), ''));

                // Display PDF in iframe
                if (iframeRef.current) {
                    console.log('apple cat dog', iframeRef.current)
                    iframeRef.current.src = `${pdfBlobUrl}#view=FitH`;
                    iframeRef.current.filename = "Custom PDF Viewer"
                }
            } catch (error) {
                console.error('Error converting PNG to PDF:', error);
            }
        };

        convertAndDisplayPDF();
    }, [data]);

//     let fileURL;
//    if (blobBuffer) {
//     const buff = Buffer.from(blobBuffer);
//     const file = new Blob([buff], { type: 'application/pdf' });
//     fileURL =  window.URL.createObjectURL(file);
//     console.log('fileURL',fileURL)
// }

    let [fileURL, setFileURL] = useState('');
   
    useEffect(() => {
        if (blobBuffer) {
            const buff = Buffer.from(blobBuffer);
            const file = new Blob([buff], { type: 'application/pdf' });
            setFileURL(window.URL.createObjectURL(file));
        }
    }, [blobBuffer]);

    return (
        <>
            {data?.file_type === 'png' ?
                <div>
                    <iframe ref={iframeRef} title="PDF Viewer" width="100%" height="600px" />

                </div>
                :
                <div style={{ height: "70vh", width: "100%" }}>
                    <iframe className='original-view-pdf' src={`${fileURL}#view=FitH`} type="application/pdf" height="100%" width="100%" style={{ border: "none", margin: 0 }} ></iframe>
                </div>
            }
        </>

    );
};

export default OriginalDocumentView;
